import script from "./PreSportsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsContainer.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsContainer.vue?vue&type=style&index=0&id=6c95692b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c95692b"]])

export default __exports__